import axios from "axios";
import axiosInstance from "./axiosSetup";
import { formatDateString } from "./fileUploadGrid";
import { toast } from "react-toastify";

export interface FileMetaRow {
    fileName: string;
    file: File;
    entityType?: string;
    entity?: string;
    documentType?: string;
    authorDate?: string;
    documentDate?: string | null;
    // fileDownloadUrl?: string;
}

interface UploadFilesProps {
    filesMeta: FileMetaRow[];
    entityMap: Record<string, any[]>;
    setFilesMeta: React.Dispatch<React.SetStateAction<FileMetaRow[]>>;
    setUploading: (val: boolean) => void;
    setUploadProgress?: (val: number) => void;
    endpoint: string;
    uploadMode?: "upload" | "confirm";
}


export const uploadFiles = async ({
    filesMeta,
    entityMap,
    setFilesMeta,
    setUploading,
    setUploadProgress,
    endpoint,
    uploadMode = "upload",

}: UploadFilesProps) => {
    setUploading(true);
    setUploadProgress?.(0);

    const failedRows: string[] = [];
    const successfulRows: string[] = [];
    const invalidRows: string[] = [];
    const typeMismatchRows: string[] = [];

    const typeRestrictedDocumentTypes = ["AGM", "QUARTERLY NOTES", "IC MEMO"];
    // console.log("FilesMeta value in uploadfiles", filesMeta)
    const rowsToUpload = filesMeta.filter(row => {
        const isExcel = /\.(xlsx|xls)$/i.test(row.fileName);
        const isFinanceInput = row.documentType === "Finance Input";

        if(isExcel && isFinanceInput) {
            const isValid = !!row.file && !!row.fileName?.trim() && !!row.documentType?.trim();
            if(!isValid) invalidRows.push(row.fileName);
            return isValid;
        }

        const isValid = 
            !!row.fileName &&
            !!row.entityType?.trim() &&
            !!row.entity?.trim() &&
            !!row.documentType?.trim() &&
            // !!row.authorDate?.toString().trim() &&
            !!row.documentDate?.toString().trim();

            if(!isValid){
                invalidRows.push(row.fileName);
                return false;
            } 
            return isValid;
        });

        if(rowsToUpload.length === 0) {
            toast.warning("All fields must be filled before upload.");
            setUploading(false);
            return;
        }



    console.log("Typemismatch rows are", typeMismatchRows);

    const total = rowsToUpload.length;
    let uploaded = 0;

    console.log("rows to upload are", rowsToUpload);

    for (const row of rowsToUpload) {

        const entityId = row.entityType ?
            entityMap[row.entityType]?.find((e: any) => e.name === row.entity)?.id : undefined;
        // console.log("entityID", entityId, "entity", row.entity);

        
        try {
            const formData = new FormData();
            if(uploadMode === 'upload') {
                formData.append("file", row.file);
                formData.append("entityType", row.entityType || "");
                formData.append("fileName", row.fileName);
                formData.append("entity", row.entity || "");
                formData.append("entityId", entityId?.toString() || "");
                formData.append("documentType", row.documentType || "");
                formData.append("authorDate", formatDateString(row.authorDate) || "");
                formData.append("documentDate", formatDateString(row.documentDate) || "");

               
            } else {
                 formData.append("entityType", row.entityType || "");
                 formData.append("fileName", row.fileName);
                 formData.append("entity", row.entity || "");
                 formData.append("entityId", entityId?.toString() || "");
                 formData.append("documentType", row.documentType || "");
                 formData.append("authorDate", row.authorDate?.toString() || "");
                 formData.append("documentDate", row.documentDate?.toString() || "");
            }
               
                await axiosInstance.post(endpoint, formData, {
                    headers: { "Content-Type": "multipart/form-data"},
                });

                console.log(`......Uploading: ${row.fileName} ----`);
                formData.forEach((value, key) => {
                    console.log(`${key}:`, value)
                });

                successfulRows.push(row.fileName);

            } catch (err) {
                console.log(err);
                failedRows.push(row.fileName);
              
            } finally {
                uploaded += 1;
                const progress = Math.round((uploaded / total ) * 100);
                setUploadProgress?.(progress);
            }
           
            }


    //Update the grid: only invalid or failed remain
        
    const filesToKeep = new Set([...failedRows, ...invalidRows]);
    
    console.log("FilesToKeep are", filesToKeep)
    console.log("FilesMeta value in uploadfiles", filesMeta)

    //Remove only successful rows
   
    setFilesMeta((prev) => prev.filter((row) => filesToKeep.has(row.fileName)));

    //Final toasts:

    // console.log("successful rows", successfulRows, "failed rows are ", failedRows)

    if (successfulRows.length > 0 && failedRows.length === 0) {
        toast.success(`${successfulRows.length} file(s) uploaded successfully.`);
    } else if (successfulRows.length > 0 && failedRows.length > 0) {
        toast.warning(`${successfulRows.length} file(s) uploaded, ${failedRows.length} failed. Please retry`);
    } else if(successfulRows.length === 0 && failedRows.length > 0) {
        toast.error(`Upload failed.Something went wrong`);
    }


    if (invalidRows.length > 0) {
        toast.warning(`Some rows are incomplete. Please update before uploading`);
    }

    
    // if(typeMismatchRows.length > 0) {
    //     toast.error("Document Type (AGM, IC Memo, Quarterly Notes must have Type as 'PM'). Please correct them");
            
    // }


    setTimeout(() => {
        setUploading(false);
        setUploadProgress?.(0);
    }, 800);
}

        